import Section from "./Section";
import Heading from "./Heading";
import {char, mascots, stickers, robot } from "../assets";

const UseCaseCard = ({ image, title, height }) => (
  <div
    className="relative overflow-hidden rounded-2xl border border-n-1/10"
    style={{ height: `${height}px` }}
  >
    <div className="absolute inset-0 p-4">
      <img
        src={image}
        className="h-full w-full object-cover rounded-xl"
        alt={title}
      />
    </div>
    <div className="absolute inset-0 flex flex-col justify-end p-4 bg-gradient-to-b from-n-8/0 to-n-8/90">
      <h4 className="text-lg font-bold text-white text-center pb-2">{title}</h4>
    </div>
  </div>
);

const UseCases = () => {
  const totalHeight = 800; // Total height in pixels
  const useCases = [
    [
      { title: "Characters", image: char, height: 600 },
      { title: "Icons", image: robot, height: 200 },
    ],
    [
      { title: "Mascots", image: mascots, height: 450 },
      { title: "Logos", image: robot, height: 350 },
    ],
    [
      { title: "Seamless Pattern", image: robot, height: 300 },
      { title: "Isometric", image: robot, height: 500 },
    ],
    [
      { title: "Drawing Book", image: robot, height: 550 },
      { title: "Stickers", image: stickers, height: 250 },
    ],
  ];

  return (
    <Section id="use-cases">
      <div className="container">
        <Heading
          className="md:max-w-md lg:max-w-2xl"
          title="Explore Use Cases"
          text="Discover the versatility of Midvector across various design needs"
        />

        <div className="grid grid-cols-4 gap-x-4 mt-10">
          {useCases.map((column, columnIndex) => (
            <div key={columnIndex} className="flex flex-col space-y-4">
              {column.map((useCase, rowIndex) => (
                <UseCaseCard
                  key={`${columnIndex}-${rowIndex}`}
                  image={useCase.image}
                  title={useCase.title}
                  height={useCase.height}
                />
              ))}
            </div>
          ))}
        </div>
      </div>
    </Section>
  );
};

export default UseCases;
